const roofConstructionData = {
  roofData: [
    { material: `China mosaic tile`, thermal_resistance: 0.005 },
    { material: `Concrete (laid to slope)`, thermal_resistance: 0.029 },
    { material: `Polyurethane foam (PUF)`, thermal_resistance: 1.739 },
    { material: `Cement screed 20mm`, thermal_resistance: 0.028 },
    { material: `Cement screed 25mm`, thermal_resistance: 0.035 },
    { material: `RCC slab 150mm`, thermal_resistance: 0.095 },
    { material: `Internal plaster 15mm`, thermal_resistance: 0.021 },
    { material: `Internal Paint-Acrylic Emulsion`, thermal_resistance: 0.002 },
    { material: `Brick bat coba 125mm`, thermal_resistance: 0.128 },
    { material: `Clay Tiles 10mm`, thermal_resistance: 0.016 },
    { material: `Exterior grade paint- Acrylic`, thermal_resistance: 0.001587302 },

    { material: `High Reflective Paint`, thermal_resistance: 0.011 },
    { material: `Gypsm Putty 10mm`, thermal_resistance: 0.02 },
    { material: `Gypsm Plaster 10mm`, thermal_resistance: 0.02 },
    { material: `XPS Sheet 50mm`, thermal_resistance: 1.563 },
    { material: `Red Earthen Tile`, thermal_resistance: 0.016 },
    { material: `Low Carbon Plaster 67mm`, thermal_resistance: 1.164 },
    { material: `15mm Plaster (External)+150mm RCC+10mm Plaster`, thermal_resistance: 0.3 },
    { material: `40mm white reflective tile; 50 mm mud phuska; Brick Bat Coba; 120 mm RCC; 10 mm (interior plaster)`, thermal_resistance: 0.53 },
    {
      material: `10mm white reflective tile; 50mm screed concrete;50mm
   Weathering course; 200mm RCC slab; 10mm Interior plaster`,
      thermal_resistance: 0.54,
    },
    {
      material: `White reflective tile (external); 40mm PUF insulation; 150mm RCC slab; 12mm Plaster (Internal)
  `,
      thermal_resistance: 1.36,
    },
    { material: `40mm china mosaic tiles; 50 mm mud phuska; Brick Bat Coba; 150 mm RCC; 10 mm (interior plaster); `, thermal_resistance: 1.16 },
    { material: `Concrete Cube  7 Days 150mm`, thermal_resistance: 0.065 },
    { material: `Marble 25mm`, thermal_resistance: 0.008 },
    { material: `Mild steel 20mm `, thermal_resistance: 0.001 },
    { material: `EPS sheet 50mm `, thermal_resistance: 1.772 },
    { material: `Concrete M-15, A-40, 7 Days 150mm`, thermal_resistance: 0.101 },
    { material: `Concrete M-25, A-40, 7 Days 150mm`, thermal_resistance: 0.119 },
    { material: `Concrete M-20, A-40, 7 Days 150mm`, thermal_resistance: 0.09 },
    { material: `Concrete M-15, A-40, 28 Days 150mm`, thermal_resistance: 0.098 },
    { material: `Concrete M-15, A-20, 7 Days 150mm`, thermal_resistance: 0.122 },
    { material: `Concrete M-25, A-40, 28 Days x150mm`, thermal_resistance: 0.114 },
    { material: `Concrete M-20, A-40, 28 Days 150mm`, thermal_resistance: 0.101 },
    { material: `Low Carbon Plaster 67mm`, thermal_resistance: 0.058 },
    { material: `Nushar Poly Insu Mortar 20mm`, thermal_resistance: 0.027 },
    { material: `Hollow Concrete Block 200mm`, thermal_resistance: 0.197 },
    { material: `Concrete M-15,A75 7 Days 220mm`, thermal_resistance: 0.189 },
    { material: `Lime concrete-10mm`, thermal_resistance: 0.014 },
    { material: `Mud Phuska-100mm`, thermal_resistance: 0.193 },
    { material: `Cement mortar-10mm`, thermal_resistance: 0.014 },
    { material: `Cement plaster-10mm`, thermal_resistance: 0.014 },
    { material: `Gypsum plaster-10mm`, thermal_resistance: 0.02 },
    { material: `Waterproofing 5mm `, thermal_resistance: 0.022 },
    { material: `Jute fibre plyboard 4.5mm ECBC R`, thermal_resistance: 0.067 },
    { material: `Rice husk 5mm ECBC R`, thermal_resistance: 0.098 },
    { material: `Rice husk 15mm ECBC R`, thermal_resistance: 0.294 },
    { material: `Ceramic Blue Tile 20mm`, thermal_resistance: 0.015 },
    { material: `Ceramic Tile - Bathroom 15mm`, thermal_resistance: 0.019 },
    { material: `Ceramic Tile 15mm`, thermal_resistance: 0.009 },
    { material: `Clay Tile 20mm`, thermal_resistance: 0.032 },
    { material: `Crystal White Tile 20mm`, thermal_resistance: 0.013 },
    { material: `Engineered Wood Floor Tiles 15mm`, thermal_resistance: 0.059 },
    { material: `Mangalore Roof Tile 20mm`, thermal_resistance: 0.033 },
    { material: `Oak Laminated Floor Tiles 15mm`, thermal_resistance: 0.057 },
    { material: `Concrete Paver Tiles 30mm`, thermal_resistance: 0.017 },
    { material: `Paver Tile 20mm`, thermal_resistance: 0.014 },
    { material: `Porcelain Tile 20mm`, thermal_resistance: 0.013 },
    { material: `Pumice Square - Bronze Tile 20mm`, thermal_resistance: 0.02 },
    { material: `Vitrified Tile 20mm`, thermal_resistance: 0.01 },
    { material: `Tiles 15mm`, thermal_resistance: 0.103 },
    { material: `Red Earthen Tile 20mm`, thermal_resistance: 0.031 },
    { material: `Antique Earthen Tile 20mm`, thermal_resistance: 0.024 },
    { material: `Beige Earthen Tile 20mm`, thermal_resistance: 0.029 },
    { material: `Handmade Earthen Tile 20mm`, thermal_resistance: 0.023 },
    { material: `White spot Earthen Tile 20mm`, thermal_resistance: 0.025 },
    { material: `Glass Tile 15mm`, thermal_resistance: 0.018 },
    { material: `Marble 25mm`, thermal_resistance: 0.008 },
    { material: `100 mm RCC`, thermal_resistance: 0.278551532 },
    { material: `100 mm RCC + 100 mm lime concrete`, thermal_resistance: 0.35971223 },
    { material: `100 mm RCC + 50 mm foam concrete + waterproofing`, thermal_resistance: 0.925925926 },
    { material: `100 mm RCC + 50 mm cinder concrete + 50 mm brick tile`, thermal_resistance: 0.483091787 },
    { material: `100 mm RCC + 75 mm cinder concrete + 50 mm brick tile`, thermal_resistance: 0.568181818 },
    { material: `115 mm RCC + 50 mm mud phuska + 50 mm brick tile`, thermal_resistance: 0.432900433 },
    { material: `115 mm RCC + 75 mm mud phuska+ 50 mm brick tile`, thermal_resistance: 0.497512438 },
    { material: `100 mm RCC + Inverted clay pots with mud phuska`, thermal_resistance: 0.42662116 },
    { material: `100 mm RCC + Extruded polystyrene 25 mm-36 kg/m3`, thermal_resistance: 1.335113485 },
    { material: `100 mm RCC + Extruded polystyrene 30 mm-36 kg/m3`, thermal_resistance: 1.519756839 },
    { material: `100 mm RCC + Extruded polystyrene 40 mm-36 kg/m3`, thermal_resistance: 1.893939394 },
    { material: `100 mm RCC + Expanded polystyrene 25 mm-24 kg/m3`, thermal_resistance: 1.074113856 },
    { material: `100 mm RCC + Expanded polystyrene 30 mm-24 kg/m3`, thermal_resistance: 1.215066829 },
    { material: `100 mm RCC + Expanded polystyrene 40 mm-24 kg/m3`, thermal_resistance: 1.492537313 },
    { material: `100 mm RCC + Expanded polystyrene 60 mm-24 kg/m3`, thermal_resistance: 2.074688797 },
    { material: `100 mm RCC + Phenolic foam 25 mm-32 kg/m3`, thermal_resistance: 1.379310345 },
    { material: `100 mm RCC + Phenolic foam 30 mm-32 kg/m3`, thermal_resistance: 1.560062402 },
    { material: `100 mm RCC + Phenolic foam 40 mm-32 kg/m3`, thermal_resistance: 1.956947162 },
    { material: `100 mm RCC + Polyurethane spray 25 mm-42 ± 2 kg/m3`, thermal_resistance: 1.506024096 },
    { material: `100 mm RCC + Polyurethane spray 30 mm-42 ± 2 kg/m3`, thermal_resistance: 1.727115717 },

    // Add any data above this commment
    // Any data added should follow the same syntax
  ],
};

export { roofConstructionData };
